<template>
  <div class="grid-x grid-margin-x">
    <div
      v-if="isMobile"
      class="cell title-mobile"
      :class="isSpacingExperimentEnabled ? 'padding-bottom-xs' : 'padding-bottom-s'"
    >
      <ProductTitle />
    </div>
    <div class="cell medium-6 large-6 xlarge-7">
      <Media />
    </div>
    <div class="cell medium-6 large-5 large-offset-1 xlarge-5 xlarge-offset-0">
      <div
        v-if="!isMobile"
        class="title"
      >
        <ProductTitle />
      </div>
      <ShopEligibleItems v-if="isMcom" />
      <ProsZoneAVertical
        v-if="!isMobile"
        data-testid="pros-section"
        class="margin-top-m"
      />
      <LazyLoadWhenInViewport>
        <SponsoredItemTop
          v-if="showSponsoredItemTop"
          :enable-click-tags-for-s-m-products="killswitches.enableClickTagsForSMProducts"
          :is-simplification-mcom-on="killswitches.priceSimplificationEnabled"
        />
      </LazyLoadWhenInViewport>
    </div>
    <div
      class="cell large-12"
      data-testid="product-details-section"
    >
      <ProductDetailsFacade :class="{'margin-top-xl': !isMobile && !showSponsoredItemTop}" />
    </div>
  </div>
</template>

<script setup>
import { SponsoredItemTop } from '@common-vue/site-monetization';
import Media from '@components/common/Media/Media';
import ProductTitle from '@components/ProductCard/ProductTitle.common';
import { ProductDetailsFacade } from '@modules/productDetails';
import ShopEligibleItems from '@components/ShopEligibleItems.vue';
import ProsZoneAVertical from '@components/pros/ProsZoneAVertical';
import { useFeatureEligibility, useKillswitches } from '@modules/featureControl';
import { useBrand } from '@composables/useBrand';
import { useDeviceType } from '@composables/utils/useDeviceType';
import LazyLoadWhenInViewport from '@components/common/LazyLoadWhenInViewport';
import { useExperiments } from '@composables/useExperiments';

const { killswitches } = useKillswitches();
const { showSponsoredItemTop } = useFeatureEligibility();
const { isMcom } = useBrand();
const { isMobile } = useDeviceType();
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();
</script>

<style lang="scss" brand="mcom" scoped>
@import "~settingSCSS";
@include title;
</style>

<style lang="scss" brand="bcom" scoped>
@import "~settingSCSS";
@include title;
</style>
